import { fromNullable, nothing } from 'maybeasy';
import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { chatMetadataStore } from '../../../Chatbot/ChatStores/ChatMetadataStore';
import { chatStore } from '../../../Chatbot/ChatStores/ChatStore';
import { AssistantRole } from '../../../Chatbot/Types';
import CelebrateImage from '../../../Cutesies/CelebrateImage';
import ProgressImage from '../../../Cutesies/ProgressImage';
import ActivePreview from './ActivePreview';
import CoachRoleCelebration from './CoachRole/CoachRoleCelebration';
import { previewStore } from './LearningCollectionPreviewStore';

function ChatbotPreview() {
  const [searchParams] = useSearchParams();
  const assistantRole = fromNullable<AssistantRole>(searchParams.get('as') as AssistantRole);
  const forRegistration = fromNullable<string>(searchParams.get('for_registration') as string);

  useEffect(() => {
    const role = assistantRole.getOrElseValue('default');
    chatMetadataStore.loading({
      assistantRole: role,
      courseRegistrationId: forRegistration.map(Number.parseInt),
      licenseId: nothing(),
    });

    chatStore.setInitialMessageBy(role);
    return () => previewStore.dispose();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- runs on mount only; assistantRole and forRegistration are new Maybe objects each render
  }, []);

  switch (previewStore.state.kind) {
    case 'waiting':
    case 'loading':
    case 'ready':
    case 'recommendations-incoming':
    case 'error':
    case 'publishing':
    case 'creating':
    case 'save-and-editing':
    case 'confirming-cancel':
    case 'confirming-cancel-from-publish':
    case 'confirming-cancel-from-create':
    case 'confirming-cancel-from-save-and-edit':
    case 'saving-from-publishing':
    case 'saving-from-creating':
    case 'saving-from-save-and-editing':
      return <ActivePreview />;
    case 'publish-celebration':
      switch (chatMetadataStore.assistantRole) {
        case 'default':
          return <ActivePreview />;
        case 'coach':
          return (
            <CoachRoleCelebration
              Image={CelebrateImage}
              headingText="Nice work! The collection is ready for your student."
            />
          );
      }
    case 'save-celebration':
      switch (chatMetadataStore.assistantRole) {
        case 'default':
          return <ActivePreview />;
        case 'coach':
          return (
            <CoachRoleCelebration
              Image={ProgressImage}
              headingText="Now that's progress - your collection is saved for later."
            />
          );
      }
    case 'discarding-changes':
      return <Navigate to={previewStore.state.destination} replace />;
  }
}

export default observer(ChatbotPreview);
